import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

var _ = require('lodash');
import AsyncCreatableSelect from 'react-select/async-creatable';
import Select from 'react-select';
const axios = require('axios').default;
import Popup from "reactjs-popup";
import InputMask from "react-input-mask";
import { toast } from 'react-toastify';
import contactTypeOptions from '../../shared/constants/contactTypeOptions';

const selectStyles = {
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "transparent",
    zIndex: "999"
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "40px",
    fontSize: "16px",
    borderRadius: "8px",
    borderColor: "var(--od-c-d5d7da, #d5d7da)",
    "&:hover": { borderColor: "var(--od-c-d5d7da, #d5d7da)" }
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "4px 8px",
    display: "flex",
    alignItems: "center"
  }),
  input: (base) => ({
    ...base,
    margin: "0px",
    paddingTop: "0px",
    paddingBottom: "0px"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  indicatorsContainer: (base) => ({
    ...base
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px"
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "4px"
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: "9999 !important" })
};

const inlineMenuContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "215px",
  "padding": "0px"
}

const contactTypePopupSelectStyles = {
  container: (base) => ({
    ...base,
    fontSize: "14px",
    minWidth: "280px",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "36px",
    borderRadius: "8px",
    borderColor: state.isFocused ? "#80bdff" : "var(--od-c-ced4da, #ced4da)",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
    "&:hover": { borderColor: state.isFocused ? "#80bdff" : "var(--od-c-ced4da, #ced4da)" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: () => ({ display: "none" }),
  placeholder: (base) => ({ ...base, color: "var(--od-c-6c757d, #6c757d)" }),
  menu: (base) => ({
    ...base,
    position: "relative",
    boxShadow: "none",
    marginTop: "4px",
    border: "none",
  }),
  menuList: (base) => ({ ...base, maxHeight: "200px", paddingTop: 0 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "var(--od-c-f8f9fa, #f8f9fa)" : "var(--od-c-ffffff, white)",
    color: "var(--od-c-000000, black)",
    padding: "8px 12px",
    cursor: "pointer",
    "&:active": { backgroundColor: "var(--od-c-e9ecef, #e9ecef)" },
  }),
};

const contactTypePopupContentStyle = {
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "300px",
  padding: "12px",
  zIndex: "9999",
};

const contactTypeTriggerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "38px",
  padding: "0 12px",
  borderRadius: "8px",
  border: "1px solid var(--od-c-d5d7da, #d5d7da)",
  backgroundColor: "var(--od-c-ffffff, white)",
  cursor: "pointer",
  fontSize: "14px",
};

function chipInitials(name) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0] || '')
    .join('')
    .toUpperCase();
}

const formatPhoneNumber = (phone) => {
  if (!phone) return '';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return phone;
};

const canAddOfferContact = (offerContacts) => {
  return !offerContacts.some((offerContact) => {
    return offerContact.id === undefined;
  });
}

const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const canSubmitOfferContactForm = (offerContact) => {
  var noPhoneOrValidPhone = (
    offerContact
      && offerContact.contact
      && (
        !offerContact.contact.phone
          || offerContact.contact.phone.length === 0
          || offerContact.contact.phone.replace(/[^0-9]/g, '').length === 10
      )
  )

  var noEmailOrValidEmail = (
    offerContact
      && offerContact.contact
      && (
        !offerContact.contact.email
          || offerContact.contact.email.length === 0
          || validateEmail(offerContact.contact.email)
      )
  )

  return (
    offerContact
      && offerContact.contact
      && offerContact.contact.name
      && offerContact.contact.name.length > 0
      && noPhoneOrValidPhone
      && noEmailOrValidEmail
  );
}

const formatOptionLabel = ({ value, label, title_email_preview }) => {
  return (
    <div>
      <div style={{"fontSize": "12px"}}>{label}</div>
      {title_email_preview && title_email_preview.length > 0 ? (
        <div className="text-muted" style={{"fontSize": "10px"}}>
          {title_email_preview}
        </div>
      ) : null}
    </div>
  );
};

const debouncedFetch = _.debounce((inputValue, callback, team, offerContacts) => {
  var omitContactIds = offerContacts.filter((offerContact) => {
      return offerContact.id && offerContact.contact;
    })
    .map((offerContact) => {
      return offerContact.contact.id;
    });

  var contactPromise = axios.get('/teams/' + team.id + '/contacts/autocomplete', {
      params: {
        name: inputValue,
        omit_ids: omitContactIds
      }
    })
    .then(function (response) {
      return response.data.map(function(data){
        return Object.assign({}, data, {value: data.id, label: data.name, type: "Contact"});
      });
    })

  var agentPromise = axios.get('/agents/autocomplete', {
      params: {
        name: inputValue,
        team_id: team.id
      }
    })
    .then(function (response) {
      return response.data.map(function(data){
        return Object.assign({}, data, {value: data.id, label: data.name, type: "Agent"});
      });
    })

  Promise.all([contactPromise, agentPromise]).then((values) => {
    var combined = values.flat().sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).slice(0, 20);

    callback(combined);
  });
}, 250);

const V3OfferManageContacts = ({
  csrfToken,
  team,
  offer,
  currentUser,
  offerContacts,
  offerContactsChanged,
  isNewOffer = false,
  embedded = false
}) => {
  const contactsBasePath = `/teams/${team.id}/offer_contacts/v3`;
  const [offerContactToEdit, setOfferContactToEdit] = useState(null);

  // When a caller (e.g. the V3OfferContactsCard's "Add contact" button)
  // appends an unsaved row directly to offerContacts, surface it as the
  // inline AsyncCreatableSelect form instead of letting it render as an
  // empty "?" chip. The card flow doesn't go through addOfferContact below,
  // so without this effect there's nothing to set the edit target.
  useEffect(() => {
    if (offerContactToEdit) return;
    const pending = offerContacts.find((oc) => oc.id === undefined);
    if (pending) setOfferContactToEdit(pending);
  }, [offerContacts, offerContactToEdit]);

  const createOfferContactFromContactId = async (contactId, offerContact, contactData = null) => {
    if (isNewOffer) {
      let contactInfo;
      const response = await axios.get(`/teams/${team.id}/contacts/${contactId}.json`);
      const fullContact = response.data;
      const contactName = contactData?.name || `${fullContact.first_name || ''} ${fullContact.last_name || ''}`.trim() || fullContact.name;
      contactInfo = {
        id: fullContact.id,
        name: contactName,
        email: fullContact.email,
        phone: fullContact.phone,
        contact_type: fullContact.contact_type,
        title: fullContact.title,
        company_name: fullContact.company_name
      };
      const localContact = {
        id: `local-${Date.now()}`,
        contact_id: contactId,
        contact: contactInfo
      };
      const newOfferContacts = offerContacts.map(oc =>
        oc === offerContact ? localContact : oc
      );
      offerContactsChanged(newOfferContacts);
      setOfferContactToEdit(null);
      return;
    }

    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.post(contactsBasePath, {
        v3_offer_contact: {
          v3_offer_id: offer.id,
          contact_id: contactId
        }
      });

      const newOfferContacts = offerContacts.map(oc =>
        oc === offerContact ? response.data : oc
      );
      offerContactsChanged(newOfferContacts);

      setOfferContactToEdit(null);
    } catch (error) {
      toast.error('Failed to add contact');
    }
  };

  const createOfferContactFromAgentId = async (agentId, offerContact, agentData = null) => {
    if (isNewOffer) {
      const contactInfo = agentData ? {
        id: agentData.id,
        name: agentData.name,
        email: agentData.email,
        phone: agentData.phone,
        contact_type: agentData.contact_type || 'Agent',
        title: agentData.title,
        company_name: agentData.company_name
      } : offerContact.contact;
      const localContact = {
        id: `local-${Date.now()}`,
        agent_id: agentId,
        contact: contactInfo
      };
      const newOfferContacts = offerContacts.map(oc =>
        oc === offerContact ? localContact : oc
      );
      offerContactsChanged(newOfferContacts);
      setOfferContactToEdit(null);
      return;
    }

    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.post(contactsBasePath, {
        v3_offer_contact: {
          v3_offer_id: offer.id,
          contact_attributes: {
            agent_id: agentId,
            team_id: team.id
          }
        }
      });

      const newOfferContacts = offerContacts.map(oc =>
        oc === offerContact ? response.data : oc
      );
      offerContactsChanged(newOfferContacts);

      setOfferContactToEdit(null);
    } catch (error) {
      toast.error('Failed to add agent contact');
    }
  };

  const deleteOfferContact = async (offerContact) => {
    if (isNewOffer || (typeof offerContact.id === 'string' && offerContact.id.startsWith('local-'))) {
      offerContactsChanged(offerContacts.filter(oc => oc.id !== offerContact.id));
      return;
    }

    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      await axios.delete(`${contactsBasePath}/${offerContact.id}`);

      offerContactsChanged(offerContacts.filter(oc => oc.id !== offerContact.id));
    } catch (error) {
      toast.error('Failed to remove contact');
    }
  };

  const addOfferContact = () => {
    setOfferContactToEdit(null);
    const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);

    const newContact = {
      id: undefined,
      contact: {
        name: '',
        email: '',
        phone: '',
        contact_type: '',
        title: '',
        company_name: ''
      }
    };

    const updatedContacts = [...cleanedContacts, newContact];
    offerContactsChanged(updatedContacts);
    setOfferContactToEdit(newContact);
  };

  const removeUnsavedOfferContact = () => {
    offerContactsChanged(offerContacts.filter(oc => oc.id !== undefined));
    setOfferContactToEdit(null);
  };

  const editOfferContact = (offerContact) => {
    const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);
    offerContactsChanged(cleanedContacts);

    const contactToEdit = {
      ...offerContact,
      contact: { ...offerContact.contact }
    };

    setOfferContactToEdit(contactToEdit);
  };

  const cancelEditOfferContact = () => {
    setOfferContactToEdit(null);
  };

  const saveOfferContactEdit = async () => {
    if (offerContactToEdit) {
      await updateOfferContact(offerContactToEdit);
      setOfferContactToEdit(null);
    }
  };

  const createOfferContact = async (offerContact) => {
    if (isNewOffer) {
      const localContact = {
        id: `local-${Date.now()}`,
        contact: {
          name: offerContact.contact.name,
          email: offerContact.contact.email,
          phone: offerContact.contact.phone,
          contact_type: offerContact.contact.contact_type,
          title: offerContact.contact.title,
          company_name: offerContact.contact.company_name
        }
      };
      const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);
      const newOfferContacts = [...cleanedContacts, localContact];
      offerContactsChanged(newOfferContacts);
      setOfferContactToEdit(null);
      return;
    }

    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.post(contactsBasePath, {
        v3_offer_contact: {
          v3_offer_id: offer.id,
          contact_attributes: {
            name: offerContact.contact.name,
            email: offerContact.contact.email,
            phone: offerContact.contact.phone,
            contact_type: offerContact.contact.contact_type,
            title: offerContact.contact.title,
            company_name: offerContact.contact.company_name,
            team_id: team.id
          }
        }
      });

      const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);
      const newOfferContacts = [...cleanedContacts, response.data];
      offerContactsChanged(newOfferContacts);

      setOfferContactToEdit(response.data);
    } catch (error) {
      toast.error('Failed to create contact');
    }
  };

  const updateOfferContact = async (offerContact) => {
    if (isNewOffer || (typeof offerContact.id === 'string' && offerContact.id.startsWith('local-'))) {
      const newOfferContacts = offerContacts.map(oc =>
        oc.id === offerContact.id ? offerContact : oc
      );
      offerContactsChanged(newOfferContacts);
      return;
    }

    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.patch(`${contactsBasePath}/${offerContact.id}`, {
        v3_offer_contact: {
          v3_offer_id: offer.id,
          contact_attributes: {
            id: offerContact.contact.id,
            name: offerContact.contact.name,
            email: offerContact.contact.email,
            phone: offerContact.contact.phone,
            contact_type: offerContact.contact.contact_type,
            title: offerContact.contact.title,
            company_name: offerContact.contact.company_name,
            team_id: team.id
          }
        }
      });

      const newOfferContacts = offerContacts.map(oc =>
        oc.id === offerContact.id ? response.data : oc
      );
      offerContactsChanged(newOfferContacts);
    } catch (error) {
      toast.error('Failed to update contact');
    }
  };

  const persistedContacts = offerContacts.filter(oc => oc.id !== undefined);
  const newContacts = offerContacts.filter(oc => oc.id === undefined);

  persistedContacts.sort((a, b) => {
    const nameA = (a.contact?.name || '').toLowerCase();
    const nameB = (b.contact?.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });

  const sortedContacts = [...persistedContacts, ...newContacts];

  const editingContact = sortedContacts.find(oc => {
    if (!offerContactToEdit) return false;
    if (!offerContactToEdit.id && oc.id === undefined) return oc === offerContactToEdit;
    return offerContactToEdit.id && oc.id === offerContactToEdit.id;
  });

  const nonEditingContacts = sortedContacts.filter(oc => {
    if (!offerContactToEdit) return true;
    if (!offerContactToEdit.id && oc.id === undefined) return oc !== offerContactToEdit;
    return !(offerContactToEdit.id && oc.id === offerContactToEdit.id);
  });

  // Wrap in the standalone card chrome (border + heading) only when not
  // embedded inside another container (e.g. the V3OfferContactsCard
  // accordion supplies its own chrome). Inlined as JSX — defining a Wrapper
  // function component inside render produced a fresh component type each
  // render, so React unmounted/remounted everything inside (including the
  // AsyncCreatableSelect) on every keystroke and the typed input was lost.
  const wrapperClassName = embedded ? 'v3-contacts-card--embedded' : 'v3-contacts-card';

  return (
    <div className={wrapperClassName}>
      {!embedded && <span className="v3-contacts-card__heading">Contacts</span>}
      {nonEditingContacts.length > 0 && (
        <div className="v3-contacts-chips" data-testid="v3-contacts-chips">
          {nonEditingContacts.map((offerContact, index) => {
            const contact = offerContact.contact || {};
            const roleOrTitle = contact.contact_type || contact.title;
            const chipText = [contact.name || '--', roleOrTitle].filter(Boolean).join(' · ');
            return (
              <span key={index} className="v3-contacts-chip">
                <span className="v3-contacts-chip__avatar">
                  {chipInitials(contact.name)}
                </span>
                <span className="v3-contacts-chip__text" title={chipText}>{chipText}</span>
                {currentUser.can_manage_offer_contacts && (
                  <Popup
                    arrow={false}
                    offsetY={5}
                    position="bottom right"
                    contentStyle={inlineMenuContentStyle}
                    closeOnDocumentClick
                    trigger={(
                      <button
                        type="button"
                        className="v3-contacts-chip__remove"
                        aria-label={`Manage ${contact.name || 'contact'}`}
                      >
                        <i className="fas fa-times" />
                      </button>
                    )}
                  >
                    {(close) => (
                      <div>
                        <div className="row text-left">
                          <div className="col">
                            <ul className="list-group offer-inline-menu highlight-primary">
                              <li className="list-group-item">
                                <a
                                  href="#"
                                  className="text-dark"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    close();
                                    editOfferContact(offerContact);
                                  }}
                                >
                                  <i className="text-muted fas fa-edit fa-fw mx-2"></i>
                                  <span style={{ fontWeight: 'normal' }}>Edit</span>
                                </a>
                              </li>
                              <li className="list-group-item delete-offer-li border-0">
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    close();
                                    deleteOfferContact(offerContact);
                                  }}
                                  className="text-danger"
                                >
                                  <i className="fas fa-trash fa-fw mx-2"></i>
                                  <span style={{ fontWeight: 'normal' }}>Remove</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                )}
              </span>
            );
          })}
        </div>
      )}

      {editingContact && !editingContact.id && (
        <div className="mb-4">
          <div className="mb-3">
            <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
              Name
            </label>
            <AsyncCreatableSelect
              cacheOptions
              autoFocus
              styles={selectStyles}
              placeholder="Enter name..."
              menuPortalTarget={document.querySelector('body')}
              defaultOptions
              formatOptionLabel={formatOptionLabel}
              formatCreateLabel={(label) => `Create "${label}"`}
              onCreateOption={async (label) => {
                const updatedContact = {
                  ...offerContactToEdit,
                  contact: { ...offerContactToEdit.contact, name: label }
                };
                setOfferContactToEdit(updatedContact);
                offerContactsChanged(offerContacts.map(oc =>
                  oc === offerContactToEdit ? updatedContact : oc
                ));
                await createOfferContact(updatedContact);
              }}
              onChange={(option) => {
                if (option.type === "Contact") {
                  createOfferContactFromContactId(option.id, editingContact, option);
                } else if (option.type === "Agent") {
                  createOfferContactFromAgentId(option.id, editingContact, option);
                }
              }}
              onInputChange={(inputValue, { action }) => {
                if (action === 'input-change') {
                  const updatedContact = {
                    ...offerContactToEdit,
                    contact: { ...offerContactToEdit.contact, name: inputValue }
                  };
                  setOfferContactToEdit(updatedContact);
                  offerContactsChanged(offerContacts.map(oc =>
                    oc === offerContactToEdit ? updatedContact : oc
                  ));
                }
              }}
              loadOptions={(inputValue, callback) => debouncedFetch(inputValue, callback, team, offerContacts)}
            />
          </div>
          <div className="row mb-3">
            <div className="col-6">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Email
              </label>
              <input
                type="email"
                value={offerContactToEdit.contact.email || ""}
                disabled={true}
                className="form-control"
                style={{ borderRadius: "8px", backgroundColor: "var(--od-c-fafafa, #fafafa)" }}
                placeholder="--"
              />
            </div>
            <div className="col-6">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Phone
              </label>
              <InputMask
                mask="(999) 999-9999"
                value={offerContactToEdit.contact.phone || ""}
                disabled={true}
                className="form-control"
                style={{ borderRadius: "8px", backgroundColor: "var(--od-c-fafafa, #fafafa)" }}
                placeholder="--"
                alwaysShowMask={false}
              />
            </div>
          </div>
          <div className="row align-items-end">
            <div className="col">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Contact Type
              </label>
              <select
                className="form-control"
                style={{ borderRadius: "8px", backgroundColor: "var(--od-c-fafafa, #fafafa)" }}
                value={offerContactToEdit.contact.contact_type || ""}
                disabled={true}
              >
                <option value="">Type...</option>
                <option value="Agent">Agent</option>
                <option value="Manager">Manager</option>
                <option value="Venue">Venue</option>
                <option value="Tour Manager">Tour Manager</option>
                <option value="Marketing">Marketing</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="col">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Title
              </label>
              <input
                type="text"
                value={offerContactToEdit.contact.title || ""}
                disabled={true}
                className="form-control"
                style={{ borderRadius: "8px", backgroundColor: "var(--od-c-fafafa, #fafafa)" }}
                placeholder="--"
              />
            </div>
            <div className="col">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Company
              </label>
              <input
                type="text"
                value={offerContactToEdit.contact.company_name || ""}
                disabled={true}
                className="form-control"
                style={{ borderRadius: "8px", backgroundColor: "var(--od-c-fafafa, #fafafa)" }}
                placeholder="--"
              />
            </div>
            <div className="col-auto d-flex align-items-center" style={{ height: "40px" }}>
              <button
                type="button"
                onClick={() => removeUnsavedOfferContact()}
                style={{ background: "none", border: "none", padding: "6px", cursor: "pointer" }}
              >
                <i className="far fa-trash-alt" style={{ fontSize: "20px", color: "var(--od-c-a4a7ae, #A4A7AE)" }}></i>
              </button>
            </div>
          </div>
        </div>
      )}

      {editingContact && editingContact.id && (
        <div className="mb-4">
          <div className="mb-3">
            <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
              Name
            </label>
            <input
              type="text"
              value={offerContactToEdit.contact.name || ""}
              onChange={(e) => setOfferContactToEdit({
                ...offerContactToEdit,
                contact: { ...offerContactToEdit.contact, name: e.target.value }
              })}
              autoFocus
              className="form-control"
              style={{ borderRadius: "8px" }}
              placeholder="Name"
            />
          </div>
          <div className="row mb-3">
            <div className="col-6">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Email
              </label>
              <input
                type="email"
                value={offerContactToEdit.contact.email || ""}
                onChange={(e) => setOfferContactToEdit({
                  ...offerContactToEdit,
                  contact: { ...offerContactToEdit.contact, email: e.target.value }
                })}
                className="form-control"
                style={{ borderRadius: "8px" }}
                placeholder="Email"
              />
            </div>
            <div className="col-6">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Phone
              </label>
              <InputMask
                mask="(999) 999-9999"
                value={offerContactToEdit.contact.phone || ""}
                onChange={(e) => setOfferContactToEdit({
                  ...offerContactToEdit,
                  contact: { ...offerContactToEdit.contact, phone: e.target.value }
                })}
                className="form-control"
                style={{ borderRadius: "8px" }}
                placeholder="Phone"
                alwaysShowMask={false}
              />
            </div>
          </div>
          <div className="row align-items-end">
            <div className="col">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Contact Type
              </label>
              <Popup
                arrow={false}
                offsetY={5}
                position="bottom left"
                contentStyle={contactTypePopupContentStyle}
                trigger={(open) => (
                  <div style={{
                    ...contactTypeTriggerStyle,
                    borderColor: open ? "#80bdff" : "var(--od-c-d5d7da, #d5d7da)",
                    boxShadow: open ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
                  }}>
                    <span style={{ color: offerContactToEdit.contact.contact_type ? "var(--od-c-212529, #212529)" : "var(--od-c-6c757d, #6c757d)", flex: 1 }}>
                      {offerContactToEdit.contact.contact_type || "Contact Type"}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {offerContactToEdit.contact.contact_type && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setOfferContactToEdit({
                              ...offerContactToEdit,
                              contact: { ...offerContactToEdit.contact, contact_type: '' },
                            });
                          }}
                          style={{ color: "var(--od-c-6c757d, #6c757d)", cursor: "pointer", padding: "0 4px" }}
                        >
                          <i className="fa fa-times" style={{ fontSize: "10px" }}></i>
                        </span>
                      )}
                      <i className="fa fa-chevron-down" style={{ fontSize: "10px", color: "var(--od-c-6c757d, #6c757d)" }}></i>
                    </div>
                  </div>
                )}
              >
                {(close) => (
                  <Select
                    styles={contactTypePopupSelectStyles}
                    options={contactTypeOptions}
                    placeholder="Search contact types..."
                    autoFocus
                    menuIsOpen
                    value={contactTypeOptions.find((opt) => opt.value === offerContactToEdit.contact.contact_type) || null}
                    onChange={(option) => {
                      setOfferContactToEdit({
                        ...offerContactToEdit,
                        contact: { ...offerContactToEdit.contact, contact_type: option ? option.value : '' },
                      });
                      setTimeout(() => close(), 0);
                    }}
                    controlShouldRenderValue={false}
                  />
                )}
              </Popup>
            </div>
            <div className="col">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Title
              </label>
              <input
                type="text"
                value={offerContactToEdit.contact.title || ""}
                onChange={(e) => setOfferContactToEdit({
                  ...offerContactToEdit,
                  contact: { ...offerContactToEdit.contact, title: e.target.value }
                })}
                className="form-control"
                style={{ borderRadius: "8px" }}
                placeholder="Title"
              />
            </div>
            <div className="col">
              <label className="d-block mb-1" style={{ fontSize: "14px", fontWeight: 500, color: "var(--od-c-414651, #414651)" }}>
                Company
              </label>
              <input
                type="text"
                value={offerContactToEdit.contact.company_name || ""}
                onChange={(e) => setOfferContactToEdit({
                  ...offerContactToEdit,
                  contact: { ...offerContactToEdit.contact, company_name: e.target.value }
                })}
                className="form-control"
                style={{ borderRadius: "8px" }}
                placeholder="Company"
              />
            </div>
            <div className="col-auto d-flex align-items-center" style={{ height: "40px", gap: "4px" }}>
              <button
                type="button"
                onClick={saveOfferContactEdit}
                disabled={!canSubmitOfferContactForm(offerContactToEdit)}
                style={{
                  background: "none",
                  border: "none",
                  padding: "6px",
                  cursor: canSubmitOfferContactForm(offerContactToEdit) ? "pointer" : "not-allowed",
                  opacity: canSubmitOfferContactForm(offerContactToEdit) ? 1 : 0.5
                }}
              >
                <i className="fas fa-check" style={{ fontSize: "20px", color: "var(--od-c-1982c4, #1982C4)" }}></i>
              </button>
              <button
                type="button"
                onClick={cancelEditOfferContact}
                style={{ background: "none", border: "none", padding: "6px", cursor: "pointer" }}
              >
                <i className="fas fa-times" style={{ fontSize: "20px", color: "var(--od-c-a4a7ae, #A4A7AE)" }}></i>
              </button>
            </div>
          </div>
        </div>
      )}

      {!embedded && currentUser.can_manage_offer_contacts && canAddOfferContact(offerContacts) && (
        <button
          type="button"
          onClick={addOfferContact}
          className="v3-contacts-card__add"
          data-testid="v3-contacts-add"
        >
          + Add contact
        </button>
      )}
    </div>
  );
};

V3OfferManageContacts.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  offerContacts: PropTypes.array,
  offerContactsChanged: PropTypes.func.isRequired,
  isNewOffer: PropTypes.bool,
  embedded: PropTypes.bool
};

export default V3OfferManageContacts;
